import PropTypes from 'prop-types'

const ProgramNavDropdown = ({ children }) => children ?? null

ProgramNavDropdown.propTypes = {
  children: PropTypes.node,
}

export default ProgramNavDropdown
